export default "__VITE_ASSET__DB1iA1Oy__"